import React from 'react';
import { useUserAndGameContext } from '../../contexts/UserAndGameContext';
import { Box, Typography, Button } from '@mui/material';
import InstagramFeed from '../SocialWidgets/InstagramFeed';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import EastIcon from '@mui/icons-material/East';
import { useNavigate } from 'react-router-dom';
import useNavigateToTop from '../../hooks/general/useNavigateToTop';

const NewGameHomePage = () => {
    const {
        masterPoolData,
        gameData,
        masterPoolId,
        gameId,
        gameAddress,
    } = useUserAndGameContext();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const navigateToTop = useNavigateToTop();


    const uriEncoded = (link) => {
        return encodeURI(`${encodeURIComponent(link)}`);
    }


    const handleButtonClick = (page) => {
        console.log('Button clicked', page);
        const url = `/${uriEncoded(gameAddress)}?mId=${uriEncoded(masterPoolId)}&gId=${uriEncoded(gameId)}&page=${uriEncoded(page)}`;
        console.log('URL:', url);
        navigateToTop(url);
    }

    return (
        <Box
            sx={{
                padding: '24px 0 0 0',
            }}
        >
            {/* Top Nav */}
            <Box sx={{

            }}>

            </Box>

            {/* Top Banner */}
            <Box sx={{

            }}>

            </Box>

            {/* Sub Nav*/}
            <Box>

            </Box>

            {/* League */}
            <Box sx={{
                maxWidth:'750px',
                margin:'0 auto',
                width: isMobile? '90%': '100%'
            }}>
                <Typography sx={{
                    fontSize:'24px',
                    color:'#373737',
                    fontWeight:'900',
                    textAlign:'left',
                    marginBottom:'16px'
                }}>The League</Typography>
                <Typography sx={{
                    fontSize:'16px',
                    fontWeight:'700',
                    textAlign:'left',
                    marginBottom: '16px'
                }}>
                    The 2025 Tri-State PGA Team Golf League is a thrilling, season long, team competition designed exclusively for Tri-State PGA Professionals. Get ready for fierce rivalries, stunning courses, and unforgettable moments!
                </Typography>
            </Box>

             {/* Instagram Feed */}
             <Box sx={{ marginBottom: '32px'}}>
                <InstagramFeed />
            </Box>

            {/* The Teams */}
            <Box sx={{  maxWidth:'750px',
                margin:'0 auto',  width: isMobile? '90%': '100%'}}>
                <Typography sx={{
                    fontSize:'24px',
                    color:'#373737',
                    fontWeight:'900',
                    textAlign:'left',
                    marginTop: '16px',
                    marginBottom:'16px'
                }}>The Teams</Typography>
                <Typography sx={{
                    fontSize:'16px',
                    fontWeight:'500',
                    textAlign:'left',
                    marginBottom: '16px'
                }}>
                    Following a live draft, the Tri-State PGA Team Golf League formed five powerhouse teams, each with nine elite PGA Professionals. From seasoned veterans to rising stars, these teams are ready to battle.
                </Typography>
                <Box>
                    <img style={{
                        display:'block',
                        margin:'0 auto',
                        width: '95%',
                        maxWidth: '400px',
                        height: 'auto',
                        marginBottom: '32px'
                    }} src="https://poolpartyfilestorage.blob.core.windows.net/media/TriStateTeamLogos.png" alt='Tri-State Teams' />
                </Box>
                <Button
                        className="my-pools-card-button"
                        onClick={() => {handleButtonClick('teams')}}
                        sx={{
                            marginBottom: '16px'}}
                    >
                    Meet the Teams
                    <EastIcon sx={{ fontSize: '16px' }} />
                </Button>
            </Box>

            {/* The Tournament */}
            <Box sx={{  maxWidth:'750px',
                margin:'0 auto',  width: isMobile? '90%': '100%'}}>
                <Typography sx={{
                    fontSize:'24px',
                    color:'#373737',
                    fontWeight:'900',
                    textAlign:'left',
                    marginBottom:'16px'
                }}>The Tournaments</Typography>
                <Typography sx={{
                    fontSize:'16px',
                    fontWeight:'500',
                    textAlign:'left',
                    marginBottom: '16px'
                }}>
                The 2025 season unfolds across four premier golf courses, each presenting unique challenges for our teams. From lush fairways to demanding greens, these events test skill and strategy. Explore the schedule and courses below!
                </Typography>
                <Box>
                    <img style={{
                        display:'block',
                        margin:'0 auto',
                        width: '95%',
                        maxWidth: '400px',
                        height: 'auto',
                        marginBottom: '16px'
                    }} src="https://poolpartyfilestorage.blob.core.windows.net/media/TriStateEventSchedule.png" alt='Tri-State Events Schedule' />
                </Box>
                <Button
                        sx={{
                            marginBottom: '16px'}}
                        className="my-pools-card-button"
                        onClick={() => {handleButtonClick('events')}}
                    >
                Explore the Schedule
                    <EastIcon sx={{ fontSize: '16px' }} />
                </Button>
            </Box>

             {/* Scoring & Standings */}
             <Box sx={{  maxWidth:'750px',
                margin:'0 auto',  width: isMobile? '90%': '100%'}}>
                <Typography sx={{
                    fontSize:'24px',
                    color:'#373737',
                    fontWeight:'900',
                    textAlign:'left',
                    marginBottom:'16px'
                }}>Scoring & Standings</Typography>
                <Typography sx={{
                    fontSize:'16px',
                    fontWeight:'500',
                    textAlign:'left',
                    marginBottom: '16px'
                }}>
                    In each event, teams will count their TOP FOUR SCORES from nine players, making every shot count. The season-long leaderboard tracks team performance and individual performance. Stay updated on who’s leading the race to become the 2025 champions!
                </Typography>
                <img style={{
                    display:'block',
                    margin:'0 auto',
                    marginBottom: '24px'
                }} src="https://poolpartyfilestorage.blob.core.windows.net/media/tri-state-game-standings.png" alt='' />
                <Button
                    sx={{
                        marginBottom: '16px'}}
                    className="my-pools-card-button"
                    onClick={() => {handleButtonClick('leaderboard')}}
                >
                    Check out the Leaderboard<EastIcon sx={{ fontSize: '16px' }} />
                </Button>
            </Box>

             {/* The Prizes */}
             <Box sx={{  maxWidth:'750px',
                margin:'0 auto',  width: isMobile? '90%': '100%'}}>
                <Typography sx={{
                    fontSize:'24px',
                    color:'#373737',
                    fontWeight:'900',
                    textAlign:'left',
                    marginBottom:'16px'
                }}>The Prizes</Typography>
                <Typography sx={{
                    fontSize:'16px',
                    fontWeight:'500',
                    textAlign:'left',
                    marginBottom: '16px'
                }}>
                The Top 3 Teams with the best team stroke play score will collect a prize pool payout, trophies, and the ultimate bragging rights of the inaugural TSPGA Team Golf League Championship!
                </Typography>

                <Typography
                    sx={{
                        textAlign:'center',
                        fontSize:'24px',
                        fontWeight: '700',
                        marginBottom: '16px'
                    }}
                >
                    $10,000 Prize Pool
                </Typography>
                <img style={{
                    display:'block',
                    margin:'0 auto',
                    marginBottom: '16px'
                }} src="https://poolpartyfilestorage.blob.core.windows.net/media/tri-state-prizes.png" alt='' />
            </Box>
            {/* REACH FOUNDATION */}
            <Box sx={{  maxWidth:'750px',
                margin:'0 auto',  width: isMobile? '90%': '100%'}}>
                <Typography sx={{
                    fontSize:'24px',
                    color:'#373737',
                    fontWeight:'900',
                    textAlign:'left',
                    marginBottom:'16px'
                }}>REACH Foundation</Typography>
                <img style={{
                    display:'block',
                    margin:'0 auto',
                    marginBottom: '25px'
                }} src="https://poolpartyfilestorage.blob.core.windows.net/media/PGA-REACH-TRI-STATE-.png" alt='' />
                <Typography sx={{
                    fontSize:'16px',
                    fontWeight:'500',
                    textAlign:'left',
                    marginBottom: '25px'
                }}>
                TPGA of America REACH Foundation Tri-State is  a charitable foundation, focused on three key pillars to grow the game of golf throughout our section.
                </Typography>

                <Typography  sx={{
                    fontSize:'16px',
                    fontWeight:'500',
                    textAlign:'left',
                    marginBottom: '25px'
                }}>
                These pillars will include Youth Golf, the PGA HOPE Program, and Inclusion-based programs to provide golf to all!
                </Typography>
                <Button
                    sx={{
                        marginBottom: '25px'
                    }}
                    className="my-pools-card-button"
                    onClick={() => {
                        window.open('https://tristate.pga.com/foundation/', '_blank', 'noopener,noreferrer');
                    }}
                >
                    Donate to REACH Foundation<EastIcon sx={{ fontSize: '16px' }} />
                </Button>
            </Box>
            <Box sx={{
                    paddingTop: '32px',
                    backgroundImage:'url(https://poolpartyfilestorage.blob.core.windows.net/media/genericBelt.png)',
                    backgroundPosition: '0 50%',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    height:'250px'
                }}>

                </Box>
        </Box>
    );
}

export default NewGameHomePage;